/**
 * @fileoverview Side-by-side product comparison matrix for the Compare page.
 * Depends on dT_WhistList (dt_wishlist.js) for localStorage read/remove.
 */

var DTX_COMPARE_ICON_CLOSE =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M57,50l35.2-35.2c1.9-1.9,1.9-5.1,0-7c-1.9-1.9-5.1-1.9-7,0L50,43L14.8,7.7c-1.9-1.9-5.1-1.9-7,0c-1.9,1.9-1.9,5.1,0,7 L43,50L7.7,85.2c-1.9,1.9-1.9,5.1,0,7c1,1,2.2,1.5,3.5,1.5s2.5-0.5,3.5-1.5L50,57l35.2,35.2c1,1,2.2,1.5,3.5,1.5s2.5-0.5,3.5-1.5 c1.9-1.9,1.9-5.1,0-7L57,50z" fill="currentColor"/></svg>';

var DTX_COMPARE_ICON_REMOVE =
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg>';

var DTX_COMPARE_ICON_CART =
  '<svg width="15" height="15" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.0782 27H6.91826C5.22549 27 3.88623 25.5225 4.00765 23.7863L5.31835 7.37627C5.37906 6.60002 6.00037 6 6.74319 6H21.2567C21.9995 6 22.6173 6.59627 22.6816 7.37627L23.9923 23.7863C24.1138 25.5225 22.7744 27 21.0817 27H21.0782Z" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M10 11V3.85714C10 2.27857 11.1933 1 12.6667 1H15.3333C16.8067 1 18 2.27857 18 3.85714V11" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

var DTX_COMPARE_SPINNER =
  '<svg xmlns="http://www.w3.org/2000/svg" style="margin:auto;background:transparent;" width="40px" height="40px" viewBox="0 0 100 100"><circle cx="50" cy="50" fill="none" stroke="currentColor" stroke-width="13" r="35" stroke-dasharray="164.93361431346415 56.97787143782138"><animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.82s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform></circle></svg>';

var DTX_COMPARE_ROWS = [
  { key: 'product', label: 'Product' },
  { key: 'price', label: 'Price' },
  { key: 'sizes', label: 'Sizes' },
  { key: 'colors', label: 'Colors' },
  { key: 'availability', label: 'Availability' },
  { key: 'rating', label: 'Rating' },
  { key: 'purchase', label: 'Purchase' },
];

class dTXCompareMatrix extends HTMLElement {
  constructor() {
    super();
    this.emptyState = this.querySelector('.dtx-grid-empty');
    this.scrollWrap = this.querySelector('.compare-matrix-scroll');
    this.addToCartLabel = this.getAttribute('data-add-to-cart-label') || 'Add to cart';
    this.closeLabel = this.getAttribute('data-close-label') || 'Close';
  }

  connectedCallback() {
    this.dTWhistList = new dT_WhistList();
    this.dTWhistList.setListLocalStorageKey('dt-compare-list', ',');
    this.dTWhistList.setupGrid().then(
      function (records) {
        this.render(records);
      }.bind(this)
    );
  }

  render(records) {
    var valid = (records || []).filter(function (r) {
      return typeof r.product_handle !== 'undefined';
    });

    this.scrollWrap.innerHTML = '';

    if (!valid.length) {
      this.emptyState.classList.remove('dtx-grid-hide');
      this.emptyState.classList.add('dtx-grid-show');
      this.scrollWrap.classList.add('dtx-grid-hide');
      this.scrollWrap.classList.remove('dtx-grid-show');
      return;
    }

    this.emptyState.classList.remove('dtx-grid-show');
    this.emptyState.classList.add('dtx-grid-hide');
    this.scrollWrap.classList.remove('dtx-grid-hide');
    this.scrollWrap.classList.add('dtx-grid-show');

    var table = document.createElement('table');
    table.className = 'compare-matrix-table';
    table.style.setProperty('--col-count', valid.length);
    var tbody = document.createElement('tbody');

    DTX_COMPARE_ROWS.forEach(
      function (rowDef) {
        var tr = document.createElement('tr');
        tr.className = 'compare-row compare-row--' + rowDef.key;

        var th = document.createElement('th');
        th.textContent = rowDef.label;
        th.scope = 'row';
        tr.appendChild(th);

        valid.forEach(
          function (record, index) {
            var td = document.createElement('td');
            td.setAttribute('data-handle', record.product_handle);
            td.style.setProperty('--col-index', index);
            td.classList.add('col-entering');
            this.buildCell(td, rowDef.key, record);
            tr.appendChild(td);
          }.bind(this)
        );

        tbody.appendChild(tr);
      }.bind(this)
    );

    table.appendChild(tbody);
    this.scrollWrap.appendChild(table);
  }

  buildCell(td, key, record) {
    var isAvailable = record.available === 'true' || record.available === true;

    if (key === 'product') {
      td.classList.add('compare-cell-product');

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'compare-remove';
      removeBtn.setAttribute('aria-label', 'Remove ' + record.product_title);
      removeBtn.innerHTML = DTX_COMPARE_ICON_REMOVE;
      removeBtn.addEventListener('click', this.removeProduct.bind(this, record.product_handle));
      td.appendChild(removeBtn);

      var link = document.createElement('a');
      link.href = record.product_url;
      link.className = 'compare-thumb-link';
      var img = document.createElement('img');
      img.src = record.product_image;
      img.loading = 'lazy';
      img.alt = record.product_title;
      link.appendChild(img);
      td.appendChild(link);

      var title = document.createElement('a');
      title.href = record.product_url;
      title.className = 'compare-title';
      title.textContent = record.product_title;
      td.appendChild(title);
    } else if (key === 'price') {
      td.textContent = record.money_price;
    } else if (key === 'sizes') {
      td.textContent = record.sizes && record.sizes.length ? record.sizes.join(', ') : '—';
    } else if (key === 'colors') {
      if (record.colors && record.colors.length) {
        var wrap = document.createElement('div');
        wrap.className = 'compare-swatches';
        record.colors.forEach(function (c) {
          var sw = document.createElement('img');
          sw.src = c.image;
          sw.alt = c.value;
          sw.className = 'compare-swatch';
          sw.loading = 'lazy';
          wrap.appendChild(sw);
        });
        td.appendChild(wrap);
      } else {
        td.textContent = '—';
      }
    } else if (key === 'availability') {
      var dot = document.createElement('span');
      dot.className = 'compare-availability-dot ' + (isAvailable ? 'in-stock' : 'sold-out');
      td.appendChild(dot);
      var text = document.createElement('span');
      text.textContent = isAvailable ? 'In stock' : 'Sold out';
      td.appendChild(text);
    } else if (key === 'rating') {
      if (record.rating) {
        var ratingWrap = document.createElement('div');
        ratingWrap.className = 'rating';
        ratingWrap.setAttribute('role', 'img');
        var ratingNum = parseFloat(record.rating);
        var decimal = ratingNum % 1;
        var ratingDecimal = 0;
        if (decimal >= 0.3 && decimal <= 0.7) ratingDecimal = 0.5;
        else if (decimal > 0.7) ratingDecimal = 1;

        var star = document.createElement('span');
        star.className = 'rating-star';
        star.style.setProperty('--rating', Math.floor(ratingNum));
        star.style.setProperty('--rating-max', record.rating_scale || 5);
        star.style.setProperty('--rating-decimal', ratingDecimal);
        ratingWrap.appendChild(star);
        td.appendChild(ratingWrap);

        var countEl = document.createElement('p');
        countEl.className = 'compare-rating-count caption';
        countEl.textContent = '(' + record.rating_count + ')';
        td.appendChild(countEl);
      } else {
        td.textContent = 'No ratings yet';
        td.classList.add('compare-no-rating');
      }
    } else if (key === 'purchase') {
      this.buildPurchaseCell(td, record);
    }
  }

  buildPurchaseCell(td, record) {
    var opener = document.createElement('modal-opener');
    opener.setAttribute('data-modal', '#QuickAdd-list-' + record.product_handle);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'list-add-to-cart button button--full-width button--primary';
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-label', this.addToCartLabel);
    button.setAttribute('data-product-url', record.product_url);

    var iconWrap = document.createElement('span');
    iconWrap.innerHTML = DTX_COMPARE_ICON_CART;
    button.appendChild(iconWrap.firstChild);

    var labelSpan = document.createElement('span');
    labelSpan.textContent = this.addToCartLabel;
    button.appendChild(labelSpan);

    var spinner = document.createElement('div');
    spinner.className = 'loading-overlay__spinner hidden';
    spinner.innerHTML = DTX_COMPARE_SPINNER;
    button.appendChild(spinner);

    opener.appendChild(button);
    td.appendChild(opener);

    var template = document.getElementById('quick-add-modal-template');
    if (!template) return;

    var fragment = template.content.cloneNode(true);
    var modal = fragment.querySelector('quick-add-modal');
    var closeBtn = fragment.querySelector('.quick-add-modal__toggle');
    var infoDiv = fragment.querySelector('.quick-add-modal__content-info');

    modal.id = 'QuickAdd-list-' + record.product_handle;
    closeBtn.id = 'ModalClose-list-' + record.product_handle;
    infoDiv.id = 'QuickAddInfo-list-' + record.product_handle;

    td.appendChild(fragment);
  }

  removeProduct(handle) {
    this.dTWhistList.removeWhishlist(handle);

    var countBubble = document.querySelector('.dtxc-compare-count');
    if (countBubble) countBubble.setAttribute('count', this.dTWhistList.getTotalCount());

    var cells = this.scrollWrap.querySelectorAll('[data-handle="' + CSS.escape(handle) + '"]');
    if (!cells.length) return;

    cells.forEach(function (cell) {
      cell.classList.add('col-removing');
    });

    var self = this;
    setTimeout(function () {
      cells.forEach(function (cell) {
        cell.remove();
      });

      var remainingCols = self.scrollWrap.querySelectorAll('.compare-row--product td').length;
      var table = self.scrollWrap.querySelector('.compare-matrix-table');
      if (table) table.style.setProperty('--col-count', remainingCols);

      if (remainingCols === 0) {
        self.emptyState.classList.remove('dtx-grid-hide');
        self.emptyState.classList.add('dtx-grid-show');
        self.scrollWrap.classList.add('dtx-grid-hide');
        self.scrollWrap.classList.remove('dtx-grid-show');
      }
    }, 320);
  }
}

if (!customElements.get('dtx-compare-matrix')) {
  customElements.define('dtx-compare-matrix', dTXCompareMatrix);
}
